import { render, staticRenderFns } from "./downloadhistory.vue?vue&type=template&id=55c4f296&scoped=true&"
import script from "./downloadhistory.vue?vue&type=script&lang=js&"
export * from "./downloadhistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c4f296",
  null
  
)

export default component.exports